import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { UniqueSettingsConfig } from '../unique-history/unique-settings-config';

/**
 * Configuration for a DuplicateValueCheck task.
 * Checks each record for duplicates based on one or more unique fields.
 * Throws an error on the first duplicate found (routes to the error handler);
 * unique records pass through unchanged.
 */
export class DuplicateValueCheckConfig extends DestinationTaskConfigBase {
	/**
	 * Fields (and case-sensitivity) used to determine uniqueness.
	 * A record is a duplicate if another record in scope has the same values for ALL uniqueFields.
	 * @default []
	 */
	uniqueFields: { field: string; caseSensitive: boolean }[] = [];
	/** Uniqueness scope and persistence settings. */
	uniqueness: UniqueSettingsConfig;

	constructor(init?: Partial<DuplicateValueCheckConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}

		this.uniqueness ??= new UniqueSettingsConfig();
	}
}
